import { Component } from 'react'
import PropTypes from 'prop-types'
import ReactECharts from 'echarts-for-react'
import { AlertCircle } from 'lucide-react'
import { applyChartDefaults } from '../../utils/aiChartDefaults'

/**
 * AiEChartsViz Component
 *
 * Renders ECharts visualizations from API config with error boundary
 * Applies default styling to ensure uniform appearance
 */
class AiEChartsViz extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
    }
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error.message,
    }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ECharts rendering error:', error, errorInfo)
  }

  render() {
    const { config, title } = this.props
    const { hasError, error } = this.state

    if (hasError) {
      return (
        <div className="flex flex-col items-center justify-center py-12 px-4 bg-red-50 rounded-lg border border-red-200">
          <AlertCircle className="w-8 h-8 text-red-600 mb-2" />
          <p className="text-sm font-medium text-red-900 mb-1">
            Unable to render chart: {title}
          </p>
          <p className="text-xs text-red-700">
            {error || 'An error occurred while rendering this visualization'}
          </p>
        </div>
      )
    }

    try {
      // Apply default styling to AI config
      const mergedConfig = applyChartDefaults(config)

      return (
        <ReactECharts
          option={mergedConfig}
          theme="ug-dashboard"
          style={{ height: '400px', width: '100%' }}
          opts={{ renderer: 'svg' }}
          notMerge={true}
          lazyUpdate={true}
        />
      )
    } catch (err) {
      console.error('ECharts render error:', err)
      return (
        <div className="flex flex-col items-center justify-center py-12 px-4 bg-red-50 rounded-lg border border-red-200">
          <AlertCircle className="w-8 h-8 text-red-600 mb-2" />
          <p className="text-sm font-medium text-red-900 mb-1">
            Unable to render chart: {title}
          </p>
          <p className="text-xs text-red-700">{err.message}</p>
        </div>
      )
    }
  }
}

AiEChartsViz.propTypes = {
  config: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

export default AiEChartsViz
